//window.addEventListener("load", (event) => {
  /*
  const swiper2 = new Swiper(".swiper2", {
    // Optional parameters
    slidesPerView: 3.3,
    spaceBetween: 8,
    // direction: "vertical",
    loop: true,
    watchSlidesProgress: true,
    breakpoints: {
      320: {
        direction: "horizontal",
        // autoHeight: false, //enable auto height
      },
      640: {
        direction: "vertical",
        autoHeight: true, //enable auto height
      },
    },

    // And if we need scrollbar
    scrollbar: false,
  });
  */

const swiper1 = new Swiper(".swiper1", {
  // Optional parameters
  slidesPerView: 3,
  spaceBetween: 8,
  loop: true,
  
  keyboard: { enabled: true },
  zoom: {
    maxRatio: 5,
  },
  grabCursor: true,
  
  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  // Enable pagination (dots)
  pagination: {
    el: ".swiper-pagination", // Make sure you have this element in your HTML
    clickable: true, // Allows clicking on dots to navigate
  },

  breakpoints: {
    320: {
      navigation: false,
      slidesPerView: 1,
      spaceBetween: 0,
    },
    640: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    1280: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
  },

  // thumbs: {
  //   swiper: swiper2,
  // },
});

//});
